import { useAuth0 } from '@auth0/auth0-react';

import Button from '@mui/material/Button';

import { useRouter } from 'src/routes/hooks';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

import { toast } from 'src/components/snackbar';

import { signOut as jwtSignOut } from 'src/auth/context/jwt';
import { signOut as amplifySignOut } from 'src/auth/context/amplify';
import { signOut as supabaseSignOut } from 'src/auth/context/supabase';
import { signOut as firebaseSignOut } from 'src/auth/context/firebase';

// ----------------------------------------------------------------------

const signOut =
  (CONFIG.auth.method === 'supabase' && supabaseSignOut) ||
  (CONFIG.auth.method === 'firebase' && firebaseSignOut) ||
  (CONFIG.auth.method === 'amplify' && amplifySignOut) ||
  jwtSignOut;

export function SignOutButton({ title = 'Sign out', onClose, ...other }) {
  const router = useRouter();

  const { t } = useTranslate();

  const { logout: signOutAuth0 } = useAuth0();

  const handleSignOut = async () => {
    try {
      onClose?.();
      CONFIG.auth.method === 'auth0' ? await signOutAuth0() : await signOut();
      router.refresh();
    } catch (error) {
      console.error(error);
      toast.error(t('Could not sign out'));
    }
  };

  return (
    <Button fullWidth size="large" color="error" variant="soft" onClick={handleSignOut} {...other}>
      {t(title)}
    </Button>
  );
}
